import { getBrowserInfo } from "@/utils/browserInfo";
import {
  CreditHistoryEntry,
  DashboardResponse,
  ProfileModified,
  UpdateProfileData,
} from "@/../types/dashboard";
import apiClient from "../config";

export const getStudentDashboard = async (): Promise<DashboardResponse> => {
  // Get IP address using a public API
  const ipResponse = await fetch("https://api.ipify.org?format=json");
  const { ip } = await ipResponse.json();

  const browserInfo = getBrowserInfo();

  const { data } = await apiClient.post(
    `/student/loginStudent/${ip}/${browserInfo}`,
  );

  return data;
};

export const getProfileModified = async (): Promise<ProfileModified> => {
  const { data } = await apiClient.get(`/student/isProfileModified`);
  return data;
};

export const updateStudentProfile = async (
  data: UpdateProfileData,
): Promise<void> => {
  await apiClient.put("/student/updateProfile", data);
};

export async function verifyMemberByPhoneNumber(phoneNumber: string) {
  const { data } = await apiClient.get(
    `/public/verifyMemberByPhoneNumber/${phoneNumber}`,
  );
  return data;
}

export async function getStudentProfilePic(studentId: number) {
  try {
    const response = await apiClient.get(
      `/public/getStudentPics/${studentId}`,
      {
        responseType: "blob", // Get binary image data instead of JSON
      },
    );

    // Convert blob to object URL that can be used in img src
    if (response.data && response.data.size > 0) {
      return URL.createObjectURL(response.data);
    }
    return null;
  } catch (error) {
    console.error("Error fetching student profile picture:", error);
    return null;
  }
}

export async function uploadProfilePics(studentId: number, formData: FormData) {
  const response = await apiClient.put(
    `/student/addStudentPics/${studentId}`,
    formData,
    {
      headers: {},
      onUploadProgress: (progressEvent: any) => {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total,
        );
        window.dispatchEvent(
          new CustomEvent("uploadProgress", { detail: { percentCompleted } }),
        );
      },
    },
  );
  return response.data;
}

export async function getStudentCreditHistory(
  studentId: number,
  startDate: string,
  endDate: string,
): Promise<CreditHistoryEntry[]> {
  const { data } = await apiClient.get(
    `/public/getStudentCreditHistory/${studentId}/${startDate}/${endDate}`,
  );
  return data;
}

export async function getOtherStudentInfo(email: string) {
  const { data } = await apiClient.get(
    `/student/getOtherStudentInfo/${encodeURIComponent(email)}`,
  );
  return data;
}
